export default {
    imageDashboardSummary: {
        totalImagesGenerated: 'Total de imagens geradas',
        cost: 'Custo',
        imagesPerDay: 'Imagens/dia',
    },
};
